import script from "./DescargasHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./DescargasHeader.vue?vue&type=script&setup=true&lang=js"

import "./DescargasHeader.vue?vue&type=style&index=0&id=40de4987&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40de4987"]])

export default __exports__